import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

/**
 * Get categories
 */
export async function getCategoriesApi(payload = {}) {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/categories/list`,
      {
        page: payload.page || 1,
        limit: payload.limit || 10,
        search: payload.search || "",
        cat_type: payload.cat_type || "",
      },
      {
        ...getAdminAuthConfig(),
        headers: { ...getAdminAuthConfig().headers, "Content-Type": "application/json" },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Get Categories Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Categories fetch failed",
    };
  }
}

/**
 * Get category stats
 */
export async function getCategoryStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/categories/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Category Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Category stats fetch failed",
    };
  }
}

/**
 * Get single category
 */
export async function getCategoryApi(categoryId) {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/categories/view`,
      { cat_id: categoryId || "" },
      {
        ...getAdminAuthConfig(),
        headers: { ...getAdminAuthConfig().headers, "Content-Type": "application/json" },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Get Category Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Category fetch failed",
    };
  }
}

/**
 * Create category
 */
export async function createCategoryApi(payload = {}) {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/categories/create`,
      {
        cat_name: payload.cat_name || "",
        cat_meta_title: payload.cat_meta_title || "",
        cat_meta_keyword: payload.cat_meta_keyword || "",
        cat_type: payload.cat_type || "",
      },
      {
        ...getAdminAuthConfig(),
        headers: { ...getAdminAuthConfig().headers, "Content-Type": "application/json" },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Create Category Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Category creation failed",
    };
  }
}

/**
 * Update category
 */
export async function updateCategoryApi(payload = {}) {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/categories/update`,
      {
        cat_id: payload.cat_id || "",
        cat_name: payload.cat_name || "",
        cat_meta_title: payload.cat_meta_title || "",
        cat_meta_keyword: payload.cat_meta_keyword || "",
        cat_type: payload.cat_type || "",
      },
      {
        ...getAdminAuthConfig(),
        headers: { ...getAdminAuthConfig().headers, "Content-Type": "application/json" },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Update Category Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Category update failed",
    };
  }
}

/**
 * Delete category
 */
export async function deleteCategoryApi(categoryId) {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/categories/delete`,
      { cat_id: categoryId || "" },
      {
        ...getAdminAuthConfig(),
        headers: { ...getAdminAuthConfig().headers, "Content-Type": "application/json" },
      }
    );

    return res.data;
  } catch (err) {
    console.error("Delete Category Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Category deletion failed",
    };
  }
}